export interface MenuFilterItem {
  roles: string[];
  requiresFeature?: string;
}

// Pure menu-visibility predicate: role gate AND optional feature gate.
// Extracted from AppLayout so it can be unit-tested without React/MUI.
export function filterMenuItems<T extends MenuFilterItem>(
  items: T[],
  userRole: string | null,
  hasFeature: (feature: string) => boolean
): T[] {
  return items.filter((item) => {
    const roleOk = userRole ? item.roles.includes(userRole) : false;
    if (!roleOk) {
      return false;
    }
    return !item.requiresFeature || hasFeature(item.requiresFeature);
  });
}
